module.exports = __webpack_public_path__ + "assets/img/ApproveAccount@2x.2ee51ef9.png";